import {assert} from 'assert-ts';
import type {PartValueModifier, SideEffect} from 'schemaDefinition/types';
import type {WorkV4} from 'services/metadata/types';
import {isNullish} from 'schemaDefinition/functions';

export const deweySourceModifier: PartValueModifier = ({
  valuePath,
  value,
  isDefaultValue,
  part,
  entityValue,
}) => {
  assert(
    part && part.key === 'deweySource',
    'deweySourceModifier: part must have key deweySource',
    part,
  );
  assert(
    isNullish(value) || typeof value === 'string',
    'deweySourceModifier: value must be nullish or string',
    {value, part},
  );

  if (entityValue) {
    const workValue = entityValue as WorkV4;

    if (isDefaultValue) {
      //  When setting default value, use first dewey source, if any, otherwise given value
      return {value: workValue.dewey?.[0].source ?? value};
    }

    if (workValue.dewey && Array.isArray(workValue.dewey)) {
      // Create sideeffects of all deweys
      const sideEffects: SideEffect[] = workValue.dewey
        .map((d, i) => {
          return {
            valuePath: `dewey[${i}].source`,
            value,
          };
        })
        .filter(s => s.valuePath !== valuePath); // Removes current target

      // Return change with sideeffects
      if (sideEffects.length > 0) {
        return {
          value,
          sideEffects,
        };
      }
    }
  }

  return {
    value: value ?? null,
  };
};
